/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/online-store/comment
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyArticleKey,
  ShopifyBlogKey,
  ShopifyCommentKey,
  ShopifyCommentToArticleKey,
  ShopifyCommentToBlogKey,
  ShopifyCommentToShopKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyCommentKey,
  "2022-01": {
    name: "Shopify Comment",
    fields: [
      {
        name: "Article",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCommentToArticleKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "article_id" } },
        configuration: {
          relatedModelKey: ShopifyArticleKey,
        },
      },
      {
        name: "Author",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "author" } },
      },
      {
        name: "Blog",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCommentToBlogKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "blog_id" } },
        configuration: {
          relatedModelKey: ShopifyBlogKey,
        },
      },
      {
        name: "Body",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "body" } },
      },
      {
        name: "Body Html",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "body_html" } },
      },
      {
        name: "Email",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "email" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "IP",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "ip" } },
      },
      {
        name: "Published At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "published_at" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Status",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "status" } },
      },
      {
        name: "User Agent",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "user_agent" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCommentToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "comment" },
  },
  "2025-04": {
    graphQLTypename: "Comment",
    fields: [
      {
        name: "Article",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCommentToArticleKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "article_id", graphQLFieldKey: "article", skipGraphQLSelection: true },
        },
        configuration: {
          relatedModelKey: ShopifyArticleKey,
        },
      },
      {
        name: "Author",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "author",
            graphQLFieldKey: "author",
            graphQLSelection: `
            name
            email
            `,
          },
        },
      },
      {
        name: "Blog",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCommentToBlogKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "blog_id", graphQLFieldKey: "blogId", skipGraphQLSelection: true },
        },
        configuration: {
          relatedModelKey: ShopifyBlogKey,
        },
      },
      {
        name: "Body",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "body", graphQLFieldKey: "body" } },
      },
      {
        name: "Body Html",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "body_html", graphQLFieldKey: "bodyHtml" } },
      },
      {
        name: "Email",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "email" },
        },
        isDeleted: true,
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
      {
        name: "IP",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "ip", graphQLFieldKey: "ip" } },
      },
      {
        name: "Published At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "published_at", graphQLFieldKey: "publishedAt" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at", graphQLFieldKey: "createdAt" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at", graphQLFieldKey: "updatedAt" } },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "status", graphQLFieldKey: "status", isShopifyEnum: true } },
        configuration: {
          allowMultiple: false,
          options: [{ name: "PENDING" }, { name: "PUBLISHED" }, { name: "REMOVED" }, { name: "SPAM" }, { name: "UNAPPROVED" }],
          allowOther: true,
        },
      },
      {
        name: "User Agent",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "user_agent", graphQLFieldKey: "userAgent" } },
      },
      {
        name: "Is Published",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "isPublished" } },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      resource: "article.comments",
      parent: "blog.articles",
      additionalSelection: `
      article {
        id
        blog {
          id
        }
      } `,
    },
  },
};

export const ShopifyComment = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
